import { matchRoutes, useLocation } from 'react-router-dom';

import config from '@/config';
import { NAV_LABEL_PATHS } from '@/config/navigation.paths';

const activePaths = config.isProd
  ? NAV_LABEL_PATHS.filter((p) => !p.isHideOnProd)
  : NAV_LABEL_PATHS;

export const useCurrentPath = () => {
  const location = useLocation();

  const matchedRoutes = matchRoutes(activePaths, location);
  if (!matchedRoutes || !matchedRoutes[0]) {
    return '';
  }

  return matchedRoutes[0].pathname;
};
